<div>
  <mat-checkbox [checked]="control!.disabled" (change)="setDisabled($event.checked)">Disabled</mat-checkbox>
  <mat-checkbox [checked]="control!.webEnabled" [disabled]="isDisabled" (change)="setWebEnabled($event.checked)">Enable
    For Web</mat-checkbox>
</div>
